import { useQueryClient } from '@tanstack/react-query';

import { useDialogContext } from '../../../../contexts/DialogContext';
import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { remove } from '../../../../redux/api';

import { getMfaMethodsQueryKey } from './useListMfaMethods';

/**
 * Delete an MFA method with confirmation dialog
 */
export default function useDeleteMfaMethod() {
  const queryClient = useQueryClient();
  const { onConfirm } = useDialogContext();

  const mutation = useToastedMutation({
    mutationFn: async (methodId: number) => {
      await remove<never, void>(`/api/auth/mfa/methods/${methodId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getMfaMethodsQueryKey() });
    },
    successToastMessage: 'MFA method removed successfully',
    errorToastMessage: 'Failed to remove MFA method',
  });

  const onDeleteMfaMethod = (methodId: number) => {
    onConfirm({
      title: 'Confirm MFA method removal',
      body: `Are you sure you want to remove this MFA method? This will make your account less secure.`,
      onConfirm: async () => {
        mutation.mutate(methodId);
      },
    });
  };

  return {
    onDeleteMfaMethod,
    isDeleting: mutation.isPending,
  };
}
